import { InMemoryCache } from '@apollo/client';
import { GET_ARTISTS } from 'graphqls/profile';

export const initializeArtists = (cache: InMemoryCache): void => {
  cache.writeQuery({
    query: GET_ARTISTS,
    data: {},
  });
};

export default {
  resolvers: {
    Mutation: {
      setArtists: (_, { artists }, { cache }): null => {
        cache.writeQuery({
          query: GET_ARTISTS,
          data: {
            artists,
          },
        });

        return null;
      },
    },
  },
};
